<app-section id="media" ornament="right">
	<span headline i18n="media@@media.headline">Media</span>
	<screenshots></screenshots>
	<concept-art></concept-art>
</app-section>